export const Images = {
  // logo: require("../Assets/Images/logo.svg").default,
  bannerImg: require("../Assets/Images/banner.svg").default,
  fantom: require("../Assets/Images/fantom.svg").default,
  binance: require("../Assets/Images/binance.svg").default,
  bitfinex: require("../Assets/Images/bitfinex.svg").default,
  paraswap: require("../Assets/Images/paraswap.svg").default,
  globe: require("../Assets/Images/globe.svg").default,
  orangeGraph: require("../Assets/Images/orange_graph.svg").default,
  pinkGraph: require("../Assets/Images/pink_graph.svg").default,
  blueGraph: require("../Assets/Images/blue_graph.svg").default,
  network: require("../Assets/Images/network.svg").default,
  accordInc: require("../Assets/Images/accord_plus.svg").default,
  accordDec: require("../Assets/Images/accord_minus.svg").default,
  greenBubble: require("../Assets/Images/green_bubble.svg").default,
  radiantBubble: require("../Assets/Images/radiant_bubble.svg").default,
  radiantBlur: require("../Assets/Images/radiant_blur.png"),
  greenBlur: require("../Assets/Images/green_blur.png"),
  middleBlur: require("../Assets/Images/middle_blur.png"),
  triangle_left: require("../Assets/Images/triangle_left.svg").default,
  triangle_right: require("../Assets/Images/triangle_right.svg").default,
  blog1: require("../Assets/Images/blog1.jpg"),
  blog2: require("../Assets/Images/blog2.jpg"),
  blog3: require("../Assets/Images/blog3.jpg"),
  blog4: require("../Assets/Images/blog4.jpg"),
  swiperIcon: require("../Assets/Images/swiper_right.png"),
  middleBlueBlue: require("../Assets/Images/middleBlueBlur.png"),
  plansRightBlur: require("../Assets/Images/plansrightblur.png"),
  aave: require("../Assets/Images/aave.svg").default,
  matic: require("../Assets/Images/matic.svg").default,
  link: require("../Assets/Images/link.svg").default,
  rndr: require("../Assets/Images/rndr.svg").default,
  usdc: require("../Assets/Images/usdc.svg").default,
  weth: require("../Assets/Images/weth.svg").default,
  tron: require("../Assets/Images/tron.svg").default,
  iq: require("../Assets/Images/iq.svg").default,
  shield: require("../Assets/Images/shield.svg").default,
  seamless: require("../Assets/Images/seamless.svg").default,
  technical: require("../Assets/Images/technical.svg").default,
  dedicated: require("../Assets/Images/dedicated.svg").default,
  visionary: require("../Assets/Images/visionary.svg").default,
  newsletter: require("../Assets/Images/newsletter.svg").default,
  polygon: require("../Assets/Images/polygon.svg").default,
  bin: require("../Assets/Images/bin.svg").default,
  metamask: require("../Assets/Images/metamask.svg").default,
  walletConnect: require("../Assets/Images/walletconnect.svg").default,
  trustWallet: require("../Assets/Images/trustwallet.svg").default,

  // logo1: require("../Assets/Images/New_Dad/logo.png"),
  // bannerBg: require("../Assets/Images/New_Dad/bannerBg.gif"),
  tradeInc: require("../Assets/Images/New_Dad/trade_inc.png"),
  tradingHandle: require("../Assets/Images/New_Dad/trading_handle.png"),
  aparts: require("../Assets/Images/New_Dad/aparts.png"),
  articleBackground: require("../Assets/Images/New_Dad/article_bg.png"),
  articlesBg1: require("../Assets/Images/New_Dad/articlesBg1.png"),
  articlesBg2: require("../Assets/Images/New_Dad/articlesBg2.png"),
  articlesBg3: require("../Assets/Images/New_Dad/articlesBg3.png"),
  bannerGifOverlay: require("../Assets/Images/New_Dad/bannerGif_overlay.png"),
  bitGrpBg: require("../Assets/Images/New_Dad/bit_grpBg.png"),
  dollarSign: require("../Assets/Images/New_Dad/dollar_sign.png"),
  grMinus: require("../Assets/Images/New_Dad/gr_minus.png"),
  groupUsers: require("../Assets/Images/New_Dad/group_users.png"),
  grPlus: require("../Assets/Images/New_Dad/gr_plus.png"),
  grpUserWhite: require("../Assets/Images/New_Dad/grp_userWhite.png"),
  machine1: require("../Assets/Images/New_Dad/machine1.png"),
  machine2: require("../Assets/Images/New_Dad/machine2.png"),
  machine3: require("../Assets/Images/New_Dad/machine3.png"),
  bitGrp: require("../Assets/Images/New_Dad/bit_grp.png"),
  rightArrow: require("../Assets/Images/New_Dad/right_arrow.png"),

  // instagram: require("../Assets/Images/New_Dad/social_icons/instagram.png"),
  // socialIcon1: require("../Assets/Images/New_Dad/social_icons/social_Icon2.png"),
  // twitter: require("../Assets/Images/New_Dad/social_icons/twitter.png"),
  // youtube: require("../Assets/Images/New_Dad/social_icons/youtube.png"),
  // sendIcon: require("../Assets/Images/New_Dad/sendIcon.png"),

  logo: require("../Assets/Images/logo.png"),
  auto: require("../Assets/Images/new_flashLoan/auto.png"),
  manual: require("../Assets/Images/new_flashLoan/manual.png"),
  rytArrow: require("../Assets/Images/new_flashLoan/ryt_arrow.png"),
  aboutBg: require("../Assets/Images/new_flashLoan/about_bg.png"),

  // analytics: require("../Assets/Images/new_flashLoan/services/analytics.svg")
  //   .default,
  // consulting: require("../Assets/Images/new_flashLoan/services/consulting.svg")
  //   .default,
  // custom_design:
  //   require("../Assets/Images/new_flashLoan/services/custom_design.svg")
  //     .default,
  // development:
  //   require("../Assets/Images/new_flashLoan/services/development.svg").default,
  // integration:
  //   require("../Assets/Images/new_flashLoan/services/integration.svg").default,
  // training: require("../Assets/Images/new_flashLoan/services/training.svg")
  //   .default,

  twitter: require("../Assets/Images/new_flashLoan/social_icons/twitter.png"),
  telegram: require("../Assets/Images/new_flashLoan/social_icons/telegram.png"),
  mail: require("../Assets/Images/new_flashLoan/social_icons/mail.png"),
  instagram: require("../Assets/Images/new_flashLoan/social_icons/Insta.svg")
    .default,

  discord: require("../Assets/Images/new_flashLoan/discord.png"),
  tele: require("../Assets/Images/new_flashLoan/telegram.png"),
  twit: require("../Assets/Images/new_flashLoan/twitter.png"),
  topRightArrow: require("../Assets/Images/new_flashLoan/topRight_arrow.png"),
  blackBdr: require("../Assets/Images/new_flashLoan/black_bdr.png"),
  // cryptoTrading: require("../Assets/Images/new_flashLoan/crypto_trading.png"),
  // benefitsIcon: require("../Assets/Images/new_flashLoan/benefitsCard_icon.png"),

  gradient_bdr: require("../Assets/Images/new_flashLoan/gradient_bdr.png"),
  benefits_bdr: require("../Assets/Images/new_flashLoan/benefits_bdr.png"),
  services_bdr: require("../Assets/Images/new_flashLoan/services_bdr.png"),

  profile1: require("../Assets/Images/new_flashLoan/profile1.png"),
  profile2: require("../Assets/Images/new_flashLoan/profile2.png"),
  profile3: require("../Assets/Images/new_flashLoan/profile3.png"),

  mnStep1: require("../Assets/Images/new_flashLoan/manual/step1.png"),
  mnStep2: require("../Assets/Images/new_flashLoan/manual/step2.png"),
  mnStep3: require("../Assets/Images/new_flashLoan/manual/step3.png"),
  mnStep4: require("../Assets/Images/new_flashLoan/manual/step4.png"),
  mnStep5: require("../Assets/Images/new_flashLoan/manual/step5.png"),
  mnStep6: require("../Assets/Images/new_flashLoan/manual/step6.png"),

  atStep1: require("../Assets/Images/new_flashLoan/automatic/step1.png"),
  atStep2: require("../Assets/Images/new_flashLoan/automatic/step2.png"),
  atStep3: require("../Assets/Images/new_flashLoan/automatic/step3.png"),
  atStep4: require("../Assets/Images/new_flashLoan/automatic/step4.png"),
  atStep5: require("../Assets/Images/new_flashLoan/automatic/step5.png"),
  atStep6: require("../Assets/Images/new_flashLoan/automatic/step6.png"),

  bannerBg_vdo: require("../Assets/Images/bannerbg.mp4"),
  benefitBg_vdo: require("../Assets/Images/new_flashLoan/benefits_bg.mp4"),
  joinFlash_bgVideo: require("../Assets/Images/new_flashLoan/flashChain_bg.mp4"),
  BnrYlwOvlw1: require("../Assets/Images/new_flashLoan/banner_ylw_ovrly1.png"),
  BnrYlwOvlw2: require("../Assets/Images/new_flashLoan/banner_ylw_ovrly2.png"),

  planlftOvly: require("../Assets/Images/new_flashLoan/plan_lftOverlay.png"),
  planrytOvly: require("../Assets/Images/new_flashLoan/plan_rytOverlay.png"),
  bnb: require("../Assets/Images/new_flashLoan/bnb.png"),
  polygon: require("../Assets/Images/new_flashLoan/polygon.png"),

  icon1: require("../Assets/Images/new_flashLoan/icon1.svg").default,
  icon2: require("../Assets/Images/new_flashLoan/icon2.svg").default,
  exchange1: require("../Assets/Images/new_flashLoan/exchange1.svg").default,
  exchange2: require("../Assets/Images/new_flashLoan/exchange2.svg").default,
  // totalEarnedBg: require("../Assets/Images/new_flashLoan/total_earnedBg.svg")
  //   .default,
  qrCode: require("../Assets/Images/new_flashLoan/qrcode.png"),
  footerBg: require("../Assets/Images/new_flashLoan/footerBg.svg").default,


  // new images

  bannertext: require("../Assets/Images/banner-text.png"),
  aboutarrow: require("../Assets/Images/aboutarrow.png"),

  analytics: require("../Assets/Images/serviceimgone.svg")
    .default,
  consulting: require("../Assets/Images/serviceimgtwo.svg")
    .default,
  custom_design:
    require("../Assets/Images/serviceimgthree.svg")
      .default,
  development:
    require("../Assets/Images/serviceimgfour.svg").default,
  integration:
    require("../Assets/Images/serviceimgfive.svg").default,
  training: require("../Assets/Images/serviceimgsix.svg")
    .default,
  benefitsIcon: require("../Assets/Images/benefitcard_icon.png"),
  cryptoTrading: require("../Assets/Images/crypto_trading.png"),
  joinsector: require("../Assets/Images/joinsector.png"),
  leftshade: require("../Assets/Images/leftshade.png"),
  rightshade: require("../Assets/Images/rightshade.png"),

  aave: require("../Assets/Images/aave.png"),
  chainlink: require("../Assets/Images/chainlink.png"),
  frax: require("../Assets/Images/frax.png"),
  tether: require("../Assets/Images/tether.png"),
  usd: require("../Assets/Images/usd.png"),
  weth: require("../Assets/Images/weth.png"),
  wmatic: require("../Assets/Images/wmatic.png"),

  atStep1: require("../Assets/Images/step1.png"),
  atStep2: require("../Assets/Images/step2.png"),
  atStep3: require("../Assets/Images/step3.png"),
  atSteptwo3: require("../Assets/Images/steptwo3.png"),
  atStep4: require("../Assets/Images/step4.png"),
  atSteptwo4: require("../Assets/Images/steptwo4.png"),
  atStep5: require("../Assets/Images/step5.png"),
  atSteptwo5: require("../Assets/Images/steptwo5.png"),
  atStep6: require("../Assets/Images/step6.png"),

  howitworkbg: require("../Assets/Images/howitworksbg.png"),
  
  testimonialone: require("../Assets/Images/testimonialone.png"),
  testimonialtwo: require("../Assets/Images/testimonialtwo.png"),
  testimonialthree: require("../Assets/Images/testimonialthree.png"),
  totalEarnedBg: require("../Assets/Images/total_earnedBg.svg").default,
};
